import { render, staticRenderFns } from "./SmokingAlarm.vue?vue&type=template&id=0aac95cd&scoped=true"
import script from "./SmokingAlarm.vue?vue&type=script&lang=js"
export * from "./SmokingAlarm.vue?vue&type=script&lang=js"
import style0 from "./SmokingAlarm.vue?vue&type=style&index=0&id=0aac95cd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aac95cd",
  null
  
)

export default component.exports